import { useState } from "react";
import { toast } from "react-toastify";
import ButtonLoader from "@components/ui/Loaders/ButtonLoader";
import { useTranslation } from "react-i18next";
import { markMindfulnessAsDone } from "api/mindfulness";
import { BackImg, Bulb, GreenTick, NoMinduflness } from "@utils/defaultImages";

import { useNavigate } from "react-router-dom";
import MindFulnessCardView from "@features/mindfulness/MindFulnessCardView";
import EmptyPlanView from "@components/ui/EmptyPlanView";
const SingleDayMindfulness = ({ mindfulnessPlan, setMindfulnessPlan }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isMarkedAsDone, setIsMarkedAsDone] = useState(
    mindfulnessPlan?.mark_as_done
  );
  const navigate = useNavigate();

  const today = new Date().toISOString().split("T")[0];
  const planDate = mindfulnessPlan?.date;
  const canMarkAsDone = planDate && planDate <= today;

  const handleMarkDone = async () => {
    if (!mindfulnessPlan) return;

    setIsLoading(true);

    try {
      await markMindfulnessAsDone({
        date: mindfulnessPlan?.date,
        title: mindfulnessPlan?.title,
      });

      setMindfulnessPlan((prev) => ({
        ...prev,
        mark_as_done: true,
      }));
      setIsMarkedAsDone(true);
      toast.info(t("toast.statusUpdated"));
    } catch (error) {
      console.error(error);
      toast.error(t("toast.failUpdated"));

      // Rollback if API fails
      setIsMarkedAsDone(false);
    } finally {
      setIsLoading(false);
    }
  };

  if (!mindfulnessPlan) {
    return (
      <EmptyPlanView
        IconComponent={<NoMinduflness />}
        heading={t("dashboard.noMindfulnessPlanHeading")}
        description={t("dashboard.noMindfulnessPlanDescription")}
      />
    );
  }

  return (
    <div
      className="bg-white shadow-lg p-6 rounded-lg w-full max-w-full"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="flex justify-between items-center mb-4 gap-2">
        <h2 className="font-[600] text-[#fff] text-[16px] font-[Lato]">
          {t("dashboard.Your Daily Mindfulness Practice Guide")}
        </h2>
        <button
          className="bg-white rounded-full text-[#0575e6] text-[12px] font-[Lato] font-[600] py-2 px-3 min-w-[120px]"
          onClick={() => navigate("/mindfulness")}
        >
          {t("dashboard.View Details")}
        </button>
      </div>
      <div className="rounded-[17px] bg-white font-[Lato]">
        <div className="rounded-md p-2 md:p-4">
          <div className="flex  justify-between gap-2 mb-5">
            <div className="text-[#fff] cursor-default text-[12px] md:text-[16px] font-[600] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-full px-2 py-1 flex items-center gap-2 w-[fit-content]">
              <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                <Bulb />
              </p>
              <span>
                {new Date(mindfulnessPlan?.date).toDateString() ===
                new Date().toDateString()
                  ? t("TodayExercise")
                  : `${t(
                      `days.${mindfulnessPlan?.day?.toLowerCase()}`
                    )}  ’s ${t("mindfulnessCoachPreferences.Practice")}`}

                {/* 
                {t(`days.${mindfulnessPlan?.day?.toLowerCase()}`)}'s{" "}
                {t("mindfulnessCoachPreferences.Practice")} */}
              </span>
            </div>

            {canMarkAsDone &&
              (isMarkedAsDone ? (
                <button className="text-[#fff] cursor-default text-[12px] md:text-[14px] border border-[#36F136] rounded-full px-2 py-1 flex items-center gap-2 w-[fit-content]">
                  <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                    <GreenTick />
                  </p>
                </button>
              ) : (
                <button
                  className="text-[#fff] cursor-pointer text-[12px] md:text-[14px] font-[600] bg-[#36F136] rounded-full px-2 py-1 flex items-center justify-center gap-2 min-w-[136px] min-h-[36px] w-[fit-content] "
                  onClick={handleMarkDone}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <ButtonLoader />
                  ) : (
                    <>
                      <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                        <GreenTick />
                      </p>
                      <span>{t("sleepCoachPreferences.mark as done")}</span>
                    </>
                  )}
                </button>
              ))}
          </div>

          <p className="text-[#000] font-[600] text-[18px] mb-3">
            {mindfulnessPlan?.title}
          </p>

          <p className="text-[#7B7B7B] text-[18px] text-base whitespace-pre-line">
            {mindfulnessPlan?.description}
          </p>
          {mindfulnessPlan?.description_steps && (
            <MindFulnessCardView
              // dashboard={true}
              mindfulnessStepsData={mindfulnessPlan?.description_steps}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleDayMindfulness;
